module.exports = "<div class=\"row\">\n    <!-- begin col-3 -->\n    <div class=\"col-md-3 col-xs-12\">\n  \n        <app-account-sidebar></app-account-sidebar>\n  \n    </div>\n    <!-- end col-3 -->\n  \n    <div class=\"col-md-9\">\n        <app-subusers-list></app-subusers-list>\n      </div>\n  \n  \n  </div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/client/account/subusers/subusers.component.html
// module id = ./src/app/client/account/subusers/subusers.component.html
// module chunks = main